<template>
    <div :class="contentClasses" id="billboard"  style="position: relative">
        <template v-if="target === 'DASHBOARD_RIGHT'">
            <!-- <div v-for="(slots, layout_index) in billboardLayouts" :key="layout_index" class="py-0 my-0 d-flex align-center" data-cy="layout-rows">
                <div v-for="(slot, slot_index) in slots" :key="slot_index" class="d-flex py-0 my-0" data-cy="layout-columns">
                    <component :is="slot.is" :layout="slot" style="border-radius: 16px" :contain="true" />
                </div>
            </div> -->
            <v-overlay :value="isLoading" absolute>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-overlay>
            <div v-if="!isMobile" class="content-dashboard-right">
                <v-window v-if="billboardLayouts.length>1"
                    v-model="onboarding"
                >
                            <v-window-item eager v-for="(billboardLayout,index) in billboardLayouts" :key="index">
                                    <v-row v-for="(slots, row) in billboardLayout" :key="row" class="mt-0 mb-0 billboard-ro " data-cy="layout-rows">
                                        <v-col v-for="(slot, slot_index) in slots" :key="slot_index" class="layout-columns" data-cy="layout-columns">
                                            <a :href="generateBannerUrl(slot)" @click="registerClick(slot)" data-cy="billboard-right-slot" class="layout-href">
                                                <template v-if="slot.is === 'BannerImageBlockLayout'">
                                                    <img :src="slot.file"  :alt="tb('imagem publicitária')" class="layout-image"/>
                                                    <!--<div :style="'background-image: url('+slot.file+');'" class="layout-image"></div>-->
                                                </template>

                                                <template v-if="slot.is === 'VideoBlockLayout'">
                                                    <video-block-layout class="limit-video-height layout-video" :url="slot.url" :listen-for-clicks="!!slot.banner_url" :auto-play="slot.auto_play" @click="onBannerClick(slot)"></video-block-layout>
                                                </template>
                                            </a>
                                        </v-col>
                                </v-row>
                        </v-window-item>
                        </v-window>
                        <v-card-actions class="justify-space-between" v-if="billboardLayouts.length>1">
                                <!--<v-btn
                                    text
                                    @click="prev"
                                >
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>-->
                                <v-item-group
                                    v-model="onboarding"
                                    class="text-center"
                                    mandatory
                                    @change="changeTaggle"
                                >
                                    <v-item
                                    v-for="n in length"
                                    :key="`btn-${n}`"
                                    v-slot="{ active, toggle }"
                                    >
                                    <v-btn
                                        :input-value="active"
                                        icon
                                        @click="toggle"
                                    >
                                        <v-icon>mdi-record</v-icon>
                                    </v-btn>
                                    </v-item>
                                </v-item-group>
                                <!--<v-btn
                                    text
                                    @click="next"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>-->
                        </v-card-actions>
                        <div v-if="billboardLayouts.length==1">
                                <v-row v-for="(slots, row) in billboardLayouts[0]" :key="row" class="mt-0 mb-0 billboard-row" data-cy="layout-rows" >
                                    <v-col v-for="(slot, slot_index) in slots" :key="slot_index" class="layout-columns" data-cy="layout-columns">
                                        <a :href="generateBannerUrl(slot)" @click="registerClick(slot)" data-cy="billboard-right-slot" class="layout-href">
                                            <template v-if="slot.is === 'BannerImageBlockLayout'">
                                                <img :src="slot.file" :alt="tb('imagem publicitária')" class="layout-image">
                                            </template>

                                            <template v-if="slot.is === 'VideoBlockLayout'">
                                                <video-block-layout class="limit-video-height layout-video" :url="slot.url" :listen-for-clicks="!!slot.banner_url" :auto-play="slot.auto_play" @click="onBannerClick(slot)"></video-block-layout>
                                            </template>
                                        </a>
                                    </v-col>
                            </v-row>
                        </div>
            </div>
            <div v-else style="width:100%;margin:10px auto;height:auto"  >
                    <slider ref="slider" :options="options">
                        <slideritem v-for="(slots, row) in billboardLayouts" :key="row"  :style="styleCss" v-if="slots.length>0">
                                <div v-for="(slot, slot_index) in slots" :key="slot_index">
                                    <a @click="registerClick(slot,true)" @tap="registerClick(slot,true)" data-cy="billboard-right-slot" style="cursor: pointer">
                                        <template v-if="slot.is === 'BannerImageBlockLayout'">
                                        <img :src="slot.file" style="border-radius: 16px" :alt="tb('imagem publicitária')" width="100%" height="auto"></img>
                                            <!--<div class="billbord-image" :style="'background-image: url('+slot.file+')'"></div>-->
                                        </template>

                                        <template v-if="slot.is === 'VideoBlockLayout'">
                                            <video-block-layout class="limit-video-height" :url="slot.url" :listen-for-clicks="!!slot.banner_url" :auto-play="slot.auto_play" @click="onBannerClick(slot)"></video-block-layout>
                                        </template>
                                    </a>
                            </div>
                        </slideritem>
                        </slider>
            </div>
        </template>

        <template v-if="target === 'POP_UP'">
            <dismissible-banners v-if="billboardLayouts.length" :items="getActivePopupBillboards()" @rendered="registerRender" @click="registerClick($event)" @finish="finishBillboard" title="Publicidade" :isPersistent="true"></dismissible-banners>
        </template>
    </div>
</template>

<script>
import { useBannersStore } from '@/Stores/banners';
import { useBranchStore } from '@/Stores/branch';
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import { slider, slideritem } from 'vue-concise-slider'


export default {
    props: ['target'],
    components:{
        slider,
        slideritem
    },
    computed: {
        ...mapStores(useBranchStore, useBannersStore, useUserStore,useAppStore),

        contentClasses() {
            if (this.target !== 'DASHBOARD_RIGHT') return '';

            return !this.isMobile?'d-flex flex-column full-height dashboard-right-container':'';
        },
        isMobile(){
            return this.appStore.is_mobile
        }
    },

    data: () => ({
        length: 1,
        onboarding: 0,
        billboardLayouts: [],
        bannersClicked: [],
        finished: false,
        options: {
          currentPage: 0,
          inifinite:2,
          slidesToScroll: 1,
          loop:true,
          autoplay:'3000'
        },
        styleCss:{'margin-right': '2%'},
        autoPlayInterval: null,
        autoPlayDelay: 5000,
        isLoading:false,
       // styleCss:{'width': '47%','margin-right': '2%'}
    }),

    watch: {
        'branchStore.branch': {
            handler() {
                if (this.target === 'POP_UP' && !this.bannersStore.showPopupBillboards) {
                    return;
                }

                this.fetchBillboard();
            },
        },
    },
    mounted() {
        this.startAutoPlay();
    },
    beforeDestroy() {
        this.stopAutoPlay();
    },
    methods: {
        startAutoPlay() {
            if (this.billboardLayouts.length <= 1) return;

            this.stopAutoPlay(); // Limpa qualquer interval existente
            this.autoPlayInterval = setInterval(() => {
                this.next();
            }, this.autoPlayDelay);
        },
        stopAutoPlay() {
            if (this.autoPlayInterval) {
                clearInterval(this.autoPlayInterval);
                this.autoPlayInterval = null;
            }
        },
        pauseAutoPlay() {
            this.stopAutoPlay();
            // Reinicia após 10 segundos de inatividade
            setTimeout(() => {
                this.startAutoPlay();
            }, 10000);
        },

        changeTaggle(){
            this.pauseAutoPlay();
            const bannerUuids = this.billboardLayouts[this.onboarding].flat().map((it) => it.banner_uuid);
            this.registerRenders(bannerUuids);
        },
        next () {
            this.onboarding = this.onboarding + 1 === this.length
            ? 0
            : this.onboarding + 1
            const bannerUuids = this.billboardLayouts[this.onboarding].flat().map((it) => it.banner_uuid);

            this.registerRenders(bannerUuids);
        },
        prev () {
            this.onboarding = this.onboarding - 1 < 0
            ? this.length - 1
            : this.onboarding - 1

            const bannerUuids = this.billboardLayouts[this.onboarding].flat().map((it) => it.banner_uuid);

            this.registerRenders(bannerUuids);
        },
        newBaseFormData() {
            const formData = new FormData();
            formData.append('user_id', this.userStore.user.id);
            formData.append('branch_id', this.branchStore.branch.id);
            return formData;
        },

        registerRender(bannerUuid) {
            // Send render analytics for this banner
            const formData = this.newBaseFormData();
            formData.append('banner_uuid', bannerUuid);
            navigator.sendBeacon(`/api/analytics/banner/${bannerUuid}/render`, formData);
        },

        registerRenders(bannerUuids) {
            if (bannerUuids.length == 0) return;

            // Send render analytics for a group of banners
            const formData = this.newBaseFormData();
            formData.append('banner_uuids', bannerUuids.toString());
            navigator.sendBeacon('/api/analytics/banners/render', formData);
        },

        registerClick(slot,useRoute) {

            if (!this.bannersClicked.includes(slot.banner_uuid)) {
                this.bannersClicked.push(slot.banner_uuid);
                const formData = this.newBaseFormData();
                navigator.sendBeacon(`/api/analytics/banner/${slot.banner_uuid}/click`, formData);

            }
            if(useRoute){
                let url=  this.generateBannerUrl(slot)
                this.appStore.setClickBanner(true)
                this.$inertia.visit(url)
            }
        },

        generateBannerUrl(slot) {
            if (slot.banner_url?.includes('/orders/normal')) {
                if(this.isMobile){
                    let url= _.replace(slot.banner_url,window.location.origin,'')
                    return `${url}&banner=${slot.banner_uuid}`;
                }else{
                    return `${slot.banner_url}&banner=${slot.banner_uuid}`;
                }

            }

            return slot.banner_url;
        },
        fetchBillboard() {
            if (!this.branchStore.branch) return;
            if(this.target!='POP_UP')
                this.isLoading=true

            axios
                .get(`/api/billboards/${this.target}`, {
                    params: {
                        branchType: this.branchStore.branch.type?.id,
                    },
                })
                .then((response) => {
                    if (!Array.isArray(response.data) && !_.some(_.keys(response.data), key => _.startsWith(key, 'billboard_id_'))) {
                        this.isLoading = false;
                        if (this.target === 'POP_UP') this.finishBillboard();
                        return;
                    }

                    let list=[];
                    if(!this.isMobile){
                        _.each(response.data,(elem)=>{
                            if(_.size(elem)){
                                    list.push(elem)
                            }
                        })
                    }else{
                        _.each(response.data,(elem)=>{
                            if(_.size(elem)){
                                _.each(elem,(o)=>{
                                    list.push(o)
                                })
                            }
                        })
                    }
                    this.length=_.size(list)
                    this.billboardLayouts = list;

                    if (this.target === 'POP_UP') {
                        // @Note: Pop_up banners are logged elsewhere as we don't want to log something that wasn't shown yet
                        this.billboardLayouts = this.billboardLayouts.flatMap((it) => it.at(0));
                        this.bannersStore.setPopupBillboards(this.billboardLayouts);
                    } else {
                        // Compile a list of uuid's from each banner inside the slots and then log their renders
                        const bannerUuids = this.billboardLayouts[0].flat().map((it) => it.banner_uuid);

                        this.registerRenders(bannerUuids);
                        this.$nextTick(() => {
                            this.isLoading = false;
                        });
                        this.startAutoPlay();
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.error(error);
                });
        },

        finishBillboard() {
            if (!this.finished) this.$emit('finish');
            this.finished = true;
        },

        getActivePopupBillboards() {
            return this.branchStore?.branch && this.bannersStore.showPopupBillboards ? this.bannersStore.popupBillboards ?? [] : [];
        },

        onBannerClick(slot) {
            if (!slot.banner_url) {
                return;
            }

            this.registerClick(slot);

            if (slot.in_new_tab) {
                window.open(slot.banner_url, '_blank');
            } else {
                window.location.href = slot.banner_url;
            }
        },
    },
};
</script>

<style >

#billboard .v-overlay__scrim{
   background-color: transparent!important;
    border-color: transparent!important;
}

.limit-video-height {
    height: 25vh;
    position: relative;
    overflow: hidden;

}

.billboard-row {
    /* height: 25%;
    max-height: 25%;*/
    height: auto;
    min-height: 25%;
}

.layout-href {
    display: flex;
    justify-content: center;
    align-items: center;
    height: fit-content;
}

.layout-image {
    max-width: 100%;
    max-height: 25vh;
    border-radius: 16px;
    height: auto;
}

.layout-video {
    width: 100%;
    justify-content: center;
    align-items: center;
}
.layout-columns {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dashboard-right-container {
    max-height: calc(100vh - 135px);
}

.limit-video-height iframe {
    height: calc((100vw * 9) / 16);
}
.shepherd-dashboard-campaigns{
    padding-bottom: 0;
    padding-top: 6px;
}
/*.shepherd-dashboard-campaigns .layout-columns.col{
    padding:unset;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 12px;
    padding-right: 12px;
}*/

/* Transição suave entre slides */
.v-window__container {
    transition: transform 0.5s ease-in-out;
}
</style>

